var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSuper())?_c('mu-dashboard-super'):_vm._e(),(_vm.isAdminZiad())?_c('mu-dashboard-admin-ziad'):_vm._e(),(_vm.isAdminResale())?_c('mu-dashboard-admin'):_vm._e(),(_vm.isCommercial())?_c('mu-dashboard-commercial'):_vm._e(),(_vm.isUser() || _vm.isAdminClient())?_c('mu-dashboard-user'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }